import React, { useState } from "react";

import {
  Card,
  Typography,
  Pagination,
  Table,
  Popconfirm,
  message,
  Tag,
} from "antd";

import { useParams } from "react-router-dom";

import { useSelector } from "react-redux";
import { DeleteTwoTone } from "@ant-design/icons";

import useCommonListing from "../../../../components/AdminComponents/customHooks/useCommonListing";
import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";
import axiosInstance from "../../../../api/Axios";
import { GetFormattedDateTime } from "../../../../components/utils/DateTimeUtils";
import {
  ModuleColor,
  capitalizeWords,
} from "../../../../components/icons/ApplicationColor";
import SubscriptionAdd from "../../../../components/AdminComponents/Modals/SubscriptionAdd";
// import { GetFormattedDateTime } from "../../../../components/utils/DateTimeUtils";

const { Title } = Typography;
const Subscriptions = (props) => {
  const { canEdit } = props;
  // eslint-disable-next-line no-unused-vars
  const userInfo = useSelector((state) => state.user);
  const classification = useSelector(
    (state) => state.orgdeatil.customerClassification
  );
  const { id } = useParams();
  const [loadAgain, setLoadAgain] = useState(false);
  const LoadAPI = () => {
    setLoadAgain((prev) => !prev);
  };
  const [messageApi, contextHolder] = message.useMessage();
  const {
    data,
    itemsLength,
    loading,
    filterData,
    onShowSizeChange,
    onPageChange,
    handleSearchChange,
    // setFilterData,
    // handleSwitchChange,
    // handleClearAll,
    // setFilterUrl,
  } = useCommonListing({
    passSize: 10,
    passPage: 1,
    passURL: `/customer/customersubscriptions/?organization_id=${id}`,
    loadAgain: loadAgain,
    includeStatus: false,
    takeFromData: (res) => res?.data?.data,
    takeCountFrom: (res) => res?.data?.data?.length,
  });
  console.log(data);
  // eslint-disable-next-line no-unused-vars
  const { pageSize, currentPage, active, filter_url } = filterData;

  const DeleteSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "User has been removed successfully.",
      duration: 5,
    });
    props?.LoadUser();
    LoadAPI();
  };
  const DeleteFalied = () => {
    messageApi.open({
      type: "error",
      content: "Failed to remove User.",
      duration: 5,
    });
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const handleDelete = async (record) => {
    try {
      await axiosInstance.delete(
        `/customer/customersubscriptions/?id=${record?.id}`,
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      DeleteSuccessfull();
    } catch (err) {
      DeleteFalied();
    }
  };
  const columns = [
    {
      title: "Modules",
      dataIndex: "application_name",
      key: "application_name",
      align: "center",
      render: (application) => {
        return (
          <Tag
            color={ModuleColor(application)}
            style={{
              maxWidth: "18rem",
              paddingInline: "1rem",
              whiteSpace: "normal",
              wordBreak: "break-word",
            }}
          >
            <span
              className="tag-container"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                // Remove lineHeight so wrapping works
              }}
            >
              {application}
            </span>
          </Tag>
        );
      },
    },
    {
      title: "Contract ID",
      dataIndex: "contract_id",
      key: "contract_id",
    },
    // {
    //   title: "ENROLLMENT TYPE",
    //   dataIndex: "enrollment_type",
    //   key: "enrollment_type",
    // },
    {
      title: "Billing",
      dataIndex: "billing_cycle",
      key: "billing",
    },

    {
      title: "Category",
      dataIndex: "subscription_category",
      key: "subscription_category",
    },

    {
      title: "Start Date",
      dataIndex: "start_date",
      key: "start_date",
      editable: true,
      render: GetFormattedDateTime,
    },
    {
      title: "End Date",
      dataIndex: "end_date",
      key: "end_date",
      editable: true,
      render: GetFormattedDateTime,
    },
    // {
    //   title: "PRODUCTS",
    //   dataIndex: "products",
    //   key: "products",
    //   render: (applications) => (
    //     <span>
    //       {applications.map((tag, index) => {
    //         let color;

    //         if (tag.name === "CO") {
    //           color = "orange";
    //         } else if (tag.name === "JDV2") {
    //           color = "blue";
    //         } else {
    //           color = "red";
    //         }
    //         return (
    //           <Tag
    //             color={color}
    //             key={index}
    //             title={tag.description}
    //             style={{ cursor: "pointer" }}
    //           >
    //             <span style={{ color: "black", fontWeight: "500" }}>
    //               {tag.name}
    //             </span>
    //           </Tag>
    //         );
    //       })}
    //     </span>
    //   ),
    // },
    // {
    //   title: "Active",
    //   dataIndex: "status",
    //   key: "status",
    //   render: renderStatus,
    // },
    ...(true
      ? [
        {
          title: "Actions",
          dataIndex: "id",
          key: "id",
          align: "center",
          width: 100,
          fixed: "right",
          render: (text, record) => (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Popconfirm
                title={"Delete User"}
                description=" "
                onConfirm={() => handleDelete(record)}
                // onCancel={cancel}
                okText="Yes"
                cancelText="No"
                disabled={canEdit === false}
                placement="leftTop"
              >
                <DeleteTwoTone
                  title="Archive"
                  twoToneColor={canEdit === false ? "#d9d9d9" : "#eb2f96"}
                  style={{
                    cursor: canEdit === false ? "not-allowed" : "pointer",
                    fontSize: "1.6rem",
                    marginLeft: "0.7rem",
                    opacity: canEdit === false ? 0.5 : 1,
                  }}
                />
              </Popconfirm>
            </div>
          ),
          onCell: (record) => ({
            onClick: (e) => {
              if (canEdit === false) {
                e.stopPropagation();
              }
            },
          }),
        },
      ]
      : []),
  ];
  const [isBulkModalOpen, setIsBulkModalOpen] = useState(false);
  return (
    <Card style={{ width: "100%", marginBottom: "10px" }} hoverable>
      {contextHolder}
      <Title level={5} style={{ marginInline: "10px" }}>
        Associated Access Summary
      </Title>
      <CommonTopDetails
        title={`${classification ? capitalizeWords(classification) : "Customer"} Access`}
        titleSuffix={`${itemsLength || 0} module(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={true}
        filterAction={false}
        marginPass="15px"
        paddingInlinepass="10px"
        topSizeAdd="5px"
        addButtonProps={{
          modalType: "PopUP",
          modalProps: () => setIsBulkModalOpen((prev) => !prev),
          disabled: canEdit === false,
        }}
      />
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        size="small"
        loading={loading}
        className="table-container"
        style={{ margin: "1rem" }}
        pagination={false}
        scroll={{
          x: 400,
        }}
        bordered
      />

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "1rem",
        }}
      >
        <Pagination
          size="small"
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          onChange={onPageChange}
          pageSizeOptions={["5", "10", "15", "20", "50"]}
          //   showQuickJumper
          current={currentPage}
          defaultPageSize={pageSize}
          total={itemsLength}
        />
      </div>
      <SubscriptionAdd
        open={isBulkModalOpen}
        onClose={() => setIsBulkModalOpen(false)}
        userInfo={userInfo}
        course_id={id}
        LoadAPI={LoadAPI}
        callMain={props.LoadUser}
        bundle_id={id}
        ShowMessage={props?.data1?.user_count > 0 ? true : false}
      />
    </Card>
  );
};

export default Subscriptions;
